import { CText } from '@bm-js/atlascloud-ui'
import { useCmsEditorData } from '../../utils/hooks'
import { CmsModelType } from '@bm-js/atlascloud-shared'
import { getEntryTitle } from '../../utils/cms.util'
import { useTr } from '../../utils/useTr'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import CmsEditorCenterFields from './CmsEditorCenterFields'

const CmsEditorCenter = () => {
  const { activeEntry, activeModel } = useCmsEditorData()
  const { tr } = useTr()

  const getHeaderText = () => {
    if (!activeEntry || !activeModel) return ''
    let entryName = activeModel.label
    if (activeModel.type === CmsModelType.COLLECTION) {
      entryName = `${activeModel.label}: ${getEntryTitle(activeModel, activeEntry, tr)}`
    }
    return tr(TrKey.cmsEditorCenterHeader, { entryName })
  }

  if (!activeEntry || !activeModel)
    return (
      <div className=' h-full overflow-y-auto flex items-center justify-center'>
        <CText className='text-xl font-semibold text-primary-400'>
          {tr(TrKey.cmsEditorNoActiveEntry)}
        </CText>
      </div>
    )

  return (
    <>
      <CText className='text-xl font-bold text-primary-400 '>
        {getHeaderText()}
      </CText>
      <div className='mt-4'>
        <CmsEditorCenterFields />
      </div>
    </>
  )
}

export default CmsEditorCenter
